
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAcuatorGeneral50 as ObiTwowayAcuatorGeneral50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-acuator-general-50.js';
 
 
 

 
 export const ObiTwowayAcuatorGeneral50 = createComponent({
   react: React,
   tagName: 'obi-twoway-acuator-general-50',
   elementClass: ObiTwowayAcuatorGeneral50Element,
   events: {
     
   }
  });
 
 